import { Route } from "react-router-dom";

import { TypedRoute } from "../mz/router/components/TypedRoute";
import { RoutePath } from "../pages/RoutePath";

export const AppRoute = Route as TypedRoute<RoutePath>;
